import React, {createContext, useContext, useReducer} from 'react'
import {TesseractDeviceOverviewReducer} from "../reducer/TesseractDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const TesseractDeviceOverviewContext = createContext();

const TesseractDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        tesseractDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(TesseractDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <TesseractDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </TesseractDeviceOverviewContext.Provider>
    )
}
export default TesseractDeviceOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/context/TesseractDeviceOverviewContext.js